import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('app-header')
export class AppHeader extends LitElement {
  @property({ type: String }) title = 'javi.adv';
  @property({ type: Boolean }) enableBack = false;

  static styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: var(--font-body);
      height: 56px;
      padding: 0 16px;
      background-color: var(--bg-card, #1E1E1E);
      border-bottom: 1px solid #2B2B2B;
      position: relative;
      z-index: 10;
    }

    .left-section {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .header-logo {
      width: 28px;
      height: 28px;
      object-fit: contain;
    }

    .title {
      font-family: var(--font-heading);
      font-weight: 900;
      font-size: 1.1rem;
      color: var(--text-main, #F5F5F5);
      letter-spacing: -0.3px;
    }

    .back-btn {
      font-family: var(--font-body);
      font-weight: 500;
      background: none;
      border: none;
      color: var(--accent-orange, #FF6600);
      font-size: 1.2rem;
      cursor: pointer;
      padding: 4px 8px;
    }
  `;

  render() {
    return html`
      <div class="left-section">
        ${this.enableBack
          ? html`<button class="back-btn" @click=${this._goBack}>←</button>`
          : html`<img class="header-logo" src="/assets/logo/logo.svg" alt="javi.adv" />`
        }
        <span class="title">${this.title}</span>
      </div>
    `;
  }

  private _goBack() {
    window.history.back();
  }
}